module.exports = __webpack_public_path__ + "static/media/videos-and-podcasts.ee5cbc76.png";